import Vue from "vue";
import Vuex from "vuex";

import * as firebase from "firebase/app";
import "firebase/auth";

import users from "./users";
import customers from "./customers/customers";
import task from "./task/task";
import storage from "./storage/storage";
import rtpEngine from "./rtp-engine/rtp-engine";
import filenameFormat from "./filename-format/filenameFormatStore";
import tagConfigComments from "./tag-config-comments/tagConfigComments";
import tagCSV from "./tag-csv/tagCSVStore";

import calls from "./calls/calls";
import { authModule as auth } from "./auth";
import { GlobalState } from "./state";
import { UserError } from "@/lib/error";

Vue.use(Vuex);

const config = {
  apiKey: "AIzaSyAV7fUrzaKYyiWrEsukt6fVoDaZS_czd6s",
  authDomain: "orejas.firebaseapp.com",
  projectId: "orejas",
};
firebase.initializeApp(config);

export default new Vuex.Store<GlobalState>({
  state: {
    lastError: undefined,
  },
  mutations: {
    SET_ERROR(state, err: UserError) {
      state.lastError = err;
    },
    CLEAR_ERROR(state) {
      state.lastError = undefined;
    },
  },
  modules: {
    auth,
    calls,
    users,
    customers,
    storage,
    task,
    filenameFormat,
    rtpEngine,
    tagConfigComments,
    tagCSV,
  },
});
